require('es6-promise').polyfill();

import 'whatwg-fetch';
import $ from 'jquery';
import * as GraphConstants from './';

import {unlockChartsData} from '../actions';


const Highcharts = window.Highcharts;

function mergeArray(a1, a2, f) {
	if (!Array.isArray(a1) || !Array.isArray(a2)) {
		throw new Error("MergeError: not arrays");
	}

	if (a1.length !== a2.length) {
		throw new Error("ArrayMergeError: lengths mismatch");
	}

	var r = [];
	a1.forEach(function(value, index) {
		r[index] = f(value, a2[index]);
	})

	return r;
}


function annualGrowth(monthly) {
	var result = {
		cols: [],
		rows: [{
			key: "NoKey",
			values: []
		}]
	};

	monthly.cols.forEach(function(time, index) {
		var d = new Date(time);
		if (d.getMonth() === 11) {
			result.cols.push(time);
			result.rows[0].values.push(monthly.rows[0].values[index]);
		}
	});

	return result;
}

function growRateSinceJanuary(dataSerie) {
	var yearMap = {};
    var eduYearMap = {};

	dataSerie.forEach(function(data, index) {
		var d = new Date(data.x);
		var year = d.getFullYear();

		var percent = 0;
		var diff = 0;
		let eduPercent = 0;
		let eduDiff = 0;

		if (d.getMonth() === 11) {
			yearMap[year] = data.y;
			if (data.edu) {
                eduYearMap[year] = data.edu.y;
            }
		}

		if (yearMap[year - 1]) {
			diff = data.y - yearMap[year - 1];
			percent = growRate(data.y, yearMap[year - 1]);
		}

        if (data.edu) {
		    eduDiff = data.edu.y - eduYearMap[year - 1];
		    eduPercent = eduGrowRate(data.edu.y, eduYearMap[year - 1]);
        }

		data.percentSinceJan = percent;
		data.diffSinceJan = diff;
		if (data.edu) {
            data.edu.percentSinceJan = eduPercent;
            data.edu.diffSinceJan = eduDiff;
        }
	});
}

function cagr(current, first, index) {
	if (!index || !first)
		return 0;

	return (Math.pow(current / first, 1 / index) - 1) * 100;
}

function growRate(current, previous) {
	if (!previous)
		return 0;

	return ((current / previous) - 1) * 100;
}


function eduGrowRate(current, previous) {
	if (!previous) {
        if (previous === 0) {
            return 100;
        } else {
            return 0;
        }
    }
    return ((current / previous) - 1) * 100;
}

function registrarsGrowthConfiguration(data, period, context, messages, currentDrillDown, maxDrillDown) {


	var graphOptions = $.extend(true, {}, GraphConstants.defaultGraphOptions,
		GraphConstants.REGISTRAR_GROWTH, {
			tooltip: {
				pointFormatter: function() {
					return '<span style="color:' + this.series.color+ '">\u25CF</span> ' + this.series.name + ': <b>' +  Highcharts.numberFormat(this.y, 2) + '% (' + Highcharts.numberFormat(this.oldY, 0) +')</b><br/>';
				}
		    },
		}

	);

	graphOptions.series = [];
	data.forEach(function(serie, i) {
		var series = createSeries("", serie, messages);

		series.forEach(function(serie) {
			serie.data.forEach(function(d) {
				d.oldY = d.y;
				d.y = d.percentFirst;
			});

			graphOptions.series.push(serie);
		})
	});

	// Gestione se siamo nella selezione annuale.
	if (graphOptions.series && graphOptions.series[0] && graphOptions.series[0].data.length === 13) {
		for (let i=0;i<graphOptions.series.length; i++) {
			graphOptions.series[i].data.shift();
//			graphOptions.series[1].data.shift();
		}
	}


	graphOptions.yAxis.title.text = messages[context.kind+'.'+context.operation+'.yLabel'];


	return graphOptions;
}

function calculateFirstEduYear(index, eduSerie) {

	// Sett, Ott, Nov, Dic
	let values= [ eduSerie[index - 3], eduSerie[index - 2], eduSerie[index - 1], eduSerie[index] ];
	let res = 0;
	values.forEach((value, i) => {
		if (i > 0) {
			res += eduGrowRate(value,  values[i-1]);
		}
	});
	return res / (values.length - 1)
}

// Generazione della configurazione grafico crescita domini
function domainsGrowthConfiguration(series, period, context, messages, currentDrillDown, maxDrillDown) {

	if (series.length !== 6)
		throw new Error("GrowthError.wrongSeriesNumber");

	const sum = function(d1, d2) {
		return d1 + d2
	};

	let regSync = series[0];
	let regAsync = series[1];
	let delSync = series[2];
	let delAsync = series[3];


	let grow = GraphConstants.initialGrow;

	let monthlyResult = regSync;
	let crescitaMensile = messages['crescitaMensile'];
	let crescitaInizioAnno = messages['crescitaInizioAnno'];

	let crescitaMensileEdu = messages['crescitaMensileEdu'];
	let crescitaInizioAnnoEdu = messages['crescitaInizioAnnoEdu'];
    let crescitaPrimoAnnoEdu = messages['crescitaPrimoAnnoEdu'];
	let numeroDominiEdu = messages['chart.registeredDomainNameEDU'];
	monthlyResult.rows[0].values = mergeArray(
		mergeArray(regSync.rows[0].values, regAsync.rows[0].values, sum),
		mergeArray(delSync.rows[0].values, delAsync.rows[0].values, sum),
		function(d1, d2) {
			grow += d1 - d2;
			return grow;
		}
	);

	if (series[4] && series[5] && series[4].rows && series[5].rows) {

        if (series[4].rows.length === 0) {
            series[4].rows = [];
            series[4].rows[0] = {};
            series[4].cols = series[5].cols;
            series[4].rows[0].values = new Array(series[5].rows[0].values.length).fill(0);

        }


        if (series[5].rows.length === 0) {
            series[5].rows = [];
            series[5].rows[0] = {};
            series[5].cols = series[4].cols;
            series[5].rows[0].values = new Array(series[4].rows[0].values.length).fill(0);

        }

        let regEdu = series[4].rows[0].values;
        let delEdu = series[5].rows[0].values;

        let growEdu = 0;
        monthlyResult.edu = mergeArray(regEdu, delEdu,
            function (d1, d2) {
                growEdu += d1 - d2;
                return growEdu;
            });

    }

	let monthlySerie = createSeriesWithOptions(monthlyResult, {
		name: messages["chart.registeredDomainName"],
		id: 'grow',
		tooltip: {
			//Highcharts.dateFormat('%a, %e %b', this.x)
			pointFormatter: function() {

				var toolTip = '<b>' + Highcharts.dateFormat('%d %B, %Y', this.x) + '</b><br/>' +
					'<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0) + '</b><br/>';

				// Per il primo punto non aggiungiamo differenze rispetto ai punti precedenti
				if (this.index !== 0) {
					toolTip = toolTip + '<span>\u25CF</span> ' + crescitaMensile+ ': <span style="font-weight: bold; color: ' + (this.diffPrev < 0 ? '#FF0000' : '#000000') + ';">' + Highcharts.numberFormat(this.percentPrev, 2) + '% (' + Highcharts.numberFormat(this.diffPrev, 0) + ')</span><br/>';
					toolTip = toolTip + '<span>\u25CF</span> '+crescitaInizioAnno+': <span style="font-weight: bold; color: ' + (this.diffSinceJan < 0 ? '#FF0000' : '#000000') + ';">' + Highcharts.numberFormat(this.percentSinceJan, 2) + '% (' + Highcharts.numberFormat(this.diffSinceJan, 0) + ')</span><br/>';

                    if (this.edu && this.x >= Date.UTC(2018,8,20)) {
                        toolTip = toolTip + ' <span style="font-weight: bold; color: rgb(170, 70, 67);">\u25CF</span> ' + numeroDominiEdu + ': <span style="font-weight: bold; color: ' + (this.edu.diffPrev < 0 ? '#FF0000' : '#000000') + ';">' + Highcharts.numberFormat(this.edu.y, 0) + '</span><br/>';

                        if (this.x >= Date.UTC(2018,9,1)) {
                            toolTip = toolTip + '<span style="color: rgb(170, 70, 67);">\u25CF</span> ' + crescitaMensileEdu + ': <span style="font-weight: bold; color: ' + (this.edu.diffPrev < 0 ? '#FF0000' : '#000000') + ';">' + Highcharts.numberFormat(this.edu.percentPrev, 2) + '% (' + Highcharts.numberFormat(this.edu.diffPrev, 0) + ')</span><br/>';
                        }

                        if ((this.x >= Date.UTC(2018, 11, 31)) && (this.x < Date.UTC(2019, 0, 1))) {
                        	let crescitaPrimoAnnoEduValue = calculateFirstEduYear(this.index, monthlyResult.edu);
                            toolTip = toolTip + '<span style="color: rgb(170, 70, 67);">\u25CF</span> ' + crescitaPrimoAnnoEdu + ': <span style="font-weight: bold; color: ' + (crescitaPrimoAnnoEduValue < 0 ? '#FF0000' : '#000000') + ';">' + Highcharts.numberFormat(crescitaPrimoAnnoEduValue, 2) + '% (' + Highcharts.numberFormat(this.edu.y, 0) + ')</span><br/>';
						}

                        if (this.x >= Date.UTC(2019,0, 1)) {
                            toolTip = toolTip + '<span style="color: rgb(170, 70, 67);">\u25CF</span> ' + crescitaInizioAnnoEdu + ': <span style="font-weight: bold; color: ' + (this.edu.diffSinceJan < 0 ? '#FF0000' : '#000000') + ';">' + Highcharts.numberFormat(this.edu.percentSinceJan, 2) + '% (' + Highcharts.numberFormat(this.edu.diffSinceJan, 0) + ')</span><br/>';
                        }
					}
				}

				return toolTip;
			},
			headerFormat: ''
		}
	});

	var graphOptions = $.extend(true, {}, GraphConstants.defaultGraphOptions,
		GraphConstants.GROWTH
	);

	graphOptions.yAxis[0].title.text = messages["chart.registeredDomainName"];
	graphOptions.yAxis[1].title.text = messages["chart.yearGrowthRate"];

	growRateSinceJanuary(monthlySerie[0].data);
	graphOptions.series.push(monthlySerie[0]);

	/// Calcolo crescita annuale

	var yearlySeries = createSeriesWithOptions(annualGrowth(monthlyResult));
	var yearlySerieData = yearlySeries[0].data;

	// Flags della dati di crescita annuali
	let yData = [];
	yearlySerieData.forEach(function(data) {
		yData.push({
			x: data.x,
			y: data.y,
			title: Highcharts.numberFormat(data.y, 0),
			text: null
		})
	});
	graphOptions.series.push({
		data: yData,
		name: "Anni",
		type: "flags",
		onSeries: "grow",
		showInLegend: false,
		shape: "squarepin",
		y: -60,
		enableMouseTracking: false
	});

	yData = [];
	yearlySerieData.forEach(function(data, index) {
		yData.push({
			x: data.x,
			y: data.percentPrev,
			diffPrev: data.diffPrev
		});
	});
	// Crescita annuale in percentuale
	let crescitaAnno = messages['crescitaAnno'];
	graphOptions.series.push({
		data: yData,
		name: messages["chart.yearGrowthRate"],
		type: "spline",
		id: "growYearlyPercent",
		tooltip: {
			pointFormatter: function() {
				var d = new Date(this.x);
				var year = d.getFullYear();
				return crescitaAnno +' ' + year + ': <b>' + Highcharts.numberFormat(this.y, 2) + '% (' + Highcharts.numberFormat(this.diffPrev, 0) + ' domini )</b><br/>';
			},
			headerFormat: ''
		},
		yAxis: 1
	});
	return graphOptions;
}


function splineGraphConfiguration(data, period, context, messages, currentDrillDown, maxDrillDown) {

	let yLabel = messages[context.kind+"."+context.operation+".yLabel"];

	var graphOptions = $.extend(true, {},
		GraphConstants.defaultGraphOptions, {

			chart: {
				defaultSeriesType: 'area',

			},
			title: null,
			plotOptions: {
			    series: {
			      cursor: 'default'
			    },
				area: {
					stacking: 'normal',
					marker: {
						radius: 2
					},
					lineWidth: 2,
					states: {
						hover: {
							lineWidth: 1
						}
					},
				}
			},
			tooltip: {
				pointFormatter: function() {
					return pointWithPercentage(this);
				},
				footerFormat: "Tot: <b>{point.total:,.0f}</b>"
			},
			xAxis: {
				minRange: 6 * 30 * 3600 * 24 * 1000,
				gridLineWidth: 1,
			},
			yAxis: {
				title: {text: yLabel}
			}
		}
	);
	graphOptions.series = [];
	var series;

	data.forEach(function(serie, i) {
		series = createSeries("", serie, messages);

		series.forEach(function(serie) {
			graphOptions.series.push(serie);
		})
	});

	return graphOptions;
}

export function mergeSeries(data, paths) {

    let newData = [];
    let enabled=[];

    for (let i=0; i<data.length; i++) {
        enabled[i] = true;
    }

    // console.log('Stacked ', data, GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths);
    if (paths[0].merge && paths[1].merge) {

		if (data[0].rows.length === 0) {

			data[0].cols = data[1].cols;
			data[0].rows = [];
            data[0].rows.push({});
            data[0].rows[0].values =
				new Array(data[1].rows[0].values.length).fill(0);
		}
		if (data[1].rows.length === 0) {
			data[1].cols = data[0].cols;
            data[1].rows = [];
            data[1].rows.push({});
			data[1].rows[0].values =
				new Array(data[0].rows[0].values.length).fill(0);
		}

        newData[0]={};
        newData[0].cols = data[0].cols;
        newData[0].rows = data[0].rows.slice(0);

        if (data) {
            enabled[1] = false;
            newData[0].rows[0].values =
                mergeArray(data[0].rows[0].values, data[1].rows[0].values, (d1, d2) => {
                    return d1 + d2;
                });
        }
        for (let i=2; i<data.length; i++) {
        	enabled[i]=true;
            newData[i-1]= data[i];
		}

    } else {
        newData = data;
    }

    return { newData, enabled };
}


function stackedGraphConfiguration(data, period,
	context, messages, currentDrillDown, maxDrillDown) {

	var base = $.extend(true, {},
		GraphConstants.defaultGraphOptions,
		GraphConstants.defaultStackOptions);



	if (currentDrillDown===maxDrillDown)
		base.plotOptions.series.cursor = 'default';

	var graphOptions = $.extend(true, {},
		base,
		GraphConstants.periodGraphOptions[period]);


	let yLabel = messages[context.kind+"."+context.operation+".yLabel"];

	// Localizzazione etichetta asse y
	graphOptions.yAxis.title.text=yLabel;

	graphOptions.series = [];
	var series;

	let { newData, enabled }  = mergeSeries(data, GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths);

    // console.log('New ', newData);

	// Riordina le configurazioni in base delle serie effettivamente presenti
	let configuration = [];
	data.forEach((elem, i)=> {

		if (enabled[i]) {
			let key = null;
			let color = null;

			if (GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths[i]) {
                key = messages[GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths[i].key];
                color = GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths[i].color;
			}

			configuration.push(
				{
					key: key,
					color: color
				}
				);
		}
	});

	newData.forEach(function(serie, i) {
		/*let key = null;
		let color = null;
		if (GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths[i]) {
		 	key = messages[GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths[i].key];
			color = GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths[i].color;
		}
		*/

		series = createSeries(configuration[i].key, serie, messages);

		series.forEach(function(serie) {
			if (configuration[i].color) {
				serie.color=configuration[i].color;
			}
			graphOptions.series.push(serie);
		})
	});

	graphOptions.enabled = enabled;

	return graphOptions;
}


var registrarsConfigurationFunct = {
	'count': splineGraphConfiguration,
	'registrar': splineGraphConfiguration,
	'domain': splineGraphConfiguration,
	'delete': stackedGraphConfiguration,
	'registration': stackedGraphConfiguration,
	"transfer_in": stackedGraphConfiguration,
	"transfer_out": stackedGraphConfiguration,
	"contract_transfer_in": stackedGraphConfiguration,
	"contract_transfer_out": stackedGraphConfiguration,
	"growth": registrarsGrowthConfiguration
};

var registrantsConfigurationFunct = {
	'registrar': stackedGraphConfiguration,
	'delete': stackedGraphConfiguration,
	'restore': stackedGraphConfiguration,
	'renewal': stackedGraphConfiguration,
	'transfer': stackedGraphConfiguration,
	'transferWithTrade': stackedGraphConfiguration,
	'transferTotal': stackedGraphConfiguration,
	'registration': stackedGraphConfiguration,

};


var domainsConfigurationFunct = {
	'growth': domainsGrowthConfiguration,
	'registration': stackedGraphConfiguration,
	'delete': stackedGraphConfiguration,
	'renewal': stackedGraphConfiguration,
	'restore': stackedGraphConfiguration,
	'registrar': stackedGraphConfiguration,
	'transfer': stackedGraphConfiguration,
	'reassign': stackedGraphConfiguration,
	'transferWithTrade': stackedGraphConfiguration,
	'transferBulk': stackedGraphConfiguration,
	'transferTotal': stackedGraphConfiguration
};

var configurationFunct = {
	domain: domainsConfiguration,
	registrar: registrarsConfiguration,
	registrant: registrantsConfiguration
};




function registrarsConfiguration(data, period, context, messages, currentDrillDown, maxDrillDown) {
	// console.log("REGISTRARS-CONFIGURATION");
	//console.dir(context);
	return registrarsConfigurationFunct[context.operation](data, period, context, messages, currentDrillDown, maxDrillDown);
}

function registrantsConfiguration(data, period, context, messages, currentDrillDown, maxDrillDown) {
	//console.log("REGISTRANTS-CONFIGURATION");
	//console.dir(context);
	return registrantsConfigurationFunct[context.operation](data, period, context, messages, currentDrillDown, maxDrillDown);
}

function domainsConfiguration(data, period, context, messages, currentDrillDown, maxDrillDown) {
	//console.log("DOMAINS-CONFIGURATION");
	//console.dir(context);
	return domainsConfigurationFunct[context.operation](data, period, context, messages, currentDrillDown, maxDrillDown);
}




export function generateConfiguration(data, period, context, messages, currentDrillDown, maxDrillDown) {
	return configurationFunct[context.kind](data, period, context, messages, currentDrillDown, maxDrillDown);
}


// Funzione presente nella registry-stat.js a cui è stata tolta
// solamente la funzionalità  di  rest.
// La serie ottenuta è passata come parametro

export function createSeries(keyValue, result, messages) {
	var series = [];
	//console.dir("CREATE SERIES");
	//console.dir(messages);
	//console.dir(keyValue);
	//console.log("^^^^^^^^^^^^^^^^^^^^^^^^^");
	// Il risultato di una query può contenere più serie
	//for (var i = 0; i < result.rows.length; i++) {
		result.rows.forEach(function(row, i) {
		//var row = result.rows[i];
		var key = messages[row.key];
        // console.log('Key: ', key, ' da ', row.key)
		if (keyValue) {
            key = messages[keyValue];
           // console.log('Key2: ', key, ' da ', keyValue)
        }
		var data = [];

		row.values.forEach(function(value,index) {
			var firstValue = row.values[0];
			var prevValue = index > 0 ? row.values[index - 1] : 0;
			var val = {
				x: result.cols[index],
				y: value,
				percentFirst: growRate(value, firstValue),
				percentPrev: growRate(value, prevValue),
				diffFirst: value - firstValue,
				diffPrev: value - prevValue,
				cagr: cagr(value, firstValue, index)
			};
			//	    ////console.dir(val);

			data.push(val);
		});



		//console.log("key: " + key);
		////console.log("Faccio PUSH");	//console.log("Faccio PUSH");
		series.push($.extend(true, {
			data: data,
			name: key
		}, key));
	})
	//    ////console.dir(series);
	return series;
}

function createSeriesWithOptions(result, options) {
	var series = [];

	if (!options) {
		options = {};
	}

	result.rows.forEach(function(row,i) {

		var key = row.key;
		if (key === 'NoKey') {
			if (options.name)
				key = options.name;
		}

		var data = [];

		row.values.forEach(
			function(value,index) {

				var firstValue = row.values[0];
				var prevValue = index > 0 ? row.values[index - 1] : 0;


				const point = {
					x: result.cols[index],
					y: value,
					percentFirst: growRate(value, firstValue),
					percentPrev: growRate(value, prevValue),
					diffFirst: value - firstValue,
					diffPrev: value - prevValue,
					cagr: cagr(value, firstValue, index),
					index: index
				};

				if (result.edu) {

					let eduValue = result.edu[index];
                    let firstEduValue = result.edu[0];
                    let prevEduValue = index > 0 ? result.edu[index - 1] : 0;

                    point.edu = {
                        y: eduValue,
						percentFirst: eduGrowRate(eduValue, firstEduValue),
						percentPrev: eduGrowRate(eduValue, prevEduValue),
						diffFirst: eduValue - firstEduValue,
						diffPrev: eduValue - prevEduValue,
						cagr: cagr(eduValue, firstEduValue, index)
                    }
				}

                data.push(point);
			}
		);

		series.push($.extend(true, {
			data: data,
			name: key
		}, options));
	});

	return series;
}


export function buildUrls(context, drillDown, optionalParams = '') {
	let urls = [];
	let urlObject = GraphConstants.urlsConfiguration[context.kind];
	let operationUrls = urlObject.operations[context.operation];
	// Devo prendere o la base dell'operazione se presente oppure quello dell'oggetto
	let baseUrl = operationUrls.base || urlObject.base;

	//console.log("BASEURL: " + baseUrl);

	let rootURL = GraphConstants.rootURL;
	let isClickable = operationUrls.clickable;
	let timeSlice = (isClickable ? '/' + drillDown : '');
	let fullParam = '';
	operationUrls.paths.forEach(function(path) {
		fullParam = optionalParams + '&' + path.param;
		urls.push(rootURL + '/' + baseUrl + '/' + path.url + timeSlice + '?' + fullParam);
	});

	return urls;
}


export function requireUrlsFn(key, urls, fn) {

	var res = [];

	urls.forEach(function(url) {
		//console.log("FETCH " + url);
//
		res.push(fetch(url, { method: "GET", mode: 'cors', headers: { 'Content-Type': 'application/json'}})
			.then(function(response) {
				if (!response.ok) {
					return({error:response.statusText});
				} else {

					return response.json();
				}
			}).then(function(json) {
				return json;
			}).catch(function(err) {
				console.log('Error: ', err)
				 unlockChartsData();
				 return ({error:err.message});
			})
		);
	});

	Promise.all(res).then(function(values) {
		//console.dir(values);
		fn(key, values);
	});
}


function debugFields(params) {
	let fields = Object.keys(params);
	fields.forEach(function(field, i) {
		//console.log("Field: " + field + ":" + params[field]);
	});
}

export function mergeParams(prec, next) {
	let newParams = prec;

	let fields = Object.keys(next);
	fields.forEach(function(field, i) {
		//console.log("field : " + field + " next: " + next[field] + " prec: " + prec[field]);
		if (next[field]) {
			newParams[field] = next[field];
		} else {
				//console.log("Cancello field " + field + "valore: " + prec[field]);
			delete newParams[field];
		}
	})
	debugFields(newParams);

	return newParams;
}



export function buildExtraParams(params) {

	let extraParams = '';

	if (params) {
		if (Array.isArray(params)) {
			params.forEach(function(param, i) {
				extraParams += param + '&';
			});
		} else {
			// Sicuramente è un oggetto
			let keys = Object.keys(params);
			keys.forEach(function(key, i) {
				extraParams += (key + '=' + params[key] + '&');
			});
		}
	}
	return extraParams;
}


export function yearFormatter(value) {
	return Highcharts.dateFormat('%Y', value);
};


export function dayOnlyFormatter(date) {
	return Highcharts.dateFormat('%d', date);
};

export function monthOnlyFormatter(date) {
	return Highcharts.dateFormat('%m', date);
};

export function fullMonthOnlyFormatter(date) {
	return Highcharts.dateFormat('%B', date);
};

export function yearAndFullMonthFormatter(date) {
	return Highcharts.dateFormat('%B %Y', date);
};

function pointWithPercentage(point) {
	return '<span style="color:' + point.series.color + '">\u25CF</span> ' + point.series.name + ': <b>' + Highcharts.numberFormat(point.y, 0) + ' (' + Highcharts.numberFormat(point.percentage, 1) + '%)</b><br/>';
}



// WEBPACK FOOTER //
// ./src/library/GraphFunctions.js